import React from "react";
import Card from "./Card";

const Fishing = () => {
  return (
    <Card
      categoryKey="fishingGames"
      allowedTypeKeys={["fishing"]}
      categoryCode="FISHING"
      categoryLabel="ยิงปลา"
      categoryBlockedMessage="ท่านไม่สามารถเล่นประเภทเกมส์ยิงปลาได้ เนื่องจากติดเงื่อนไข"
    />
  );
};

export default Fishing;
